import { render } from "./AdminUsefulLinks.vue?vue&type=template&id=34b49c84&scoped=true&ts=true"
import script from "./AdminUsefulLinks.vue?vue&type=script&lang=ts"
export * from "./AdminUsefulLinks.vue?vue&type=script&lang=ts"

import "./AdminUsefulLinks.vue?vue&type=style&index=0&id=34b49c84&scoped=true&lang=css"
import "./AdminUsefulLinks.vue?vue&type=style&index=1&id=34b49c84&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b49c84"]])

export default __exports__